module.exports = __webpack_public_path__ + "img/kr-card-bottom-5.5008066.png";